export default "/images/error-404.png";